import * as dayjs from 'dayjs';

const _ = window._; // TODO: Replace with import once all services are being imported instead of using window.cirkulServices
const $ = window.$; // TEMPORARY. REMOVE JQUERY WHEN POSSIBLE.

console.log('[2024-10-14] analytics-tags init');

// TODO: Remove IIFE, export hook that returns reactive state and callable functions.
(() => {
  const ORDER_LOGGED_LOCAL_VARIABLE_PREFIX = 'analytics-tags:order-logged:';

  const TAG_EVENTS = {
    HOME_PAGE_VISIT: 'HOME_PAGE_VISIT',
    TRIAL_PAGE_VISIT: 'TRIAL_PAGE_VISIT',
    PODCAST_PAGE_VISIT: 'PODCAST_PAGE_VISIT',
    ADD_TO_CART: 'ADD_TO_CART',
    EMAIL_SUBSCRIBED: 'EMAIL_SUBSCRIBED',
    ORDER_PLACED: 'ORDER_PLACED',
    REFERRAL_LINK_CLICKED: 'REFERRAL_LINK_CLICKED',
    BUTTON_CLICKED: 'BUTTON_CLICKED',
    VIEWED_CART: 'VIEWED_CART',
    SUBSCRIPTION_SHIP_NOW: 'SUBSCRIPTION_SHIP_NOW',
    DETAIL_VIEW: 'DETAIL_VIEW',
    POST_PURCHASE_SURVEY_COMPLETED: 'POST_PURCHASE_SURVEY_COMPLETED',
  };

  const TAG_EVENT_HANDLERS = {
    [TAG_EVENTS.HOME_PAGE_VISIT]: [_logRainEvent],
    [TAG_EVENTS.TRIAL_PAGE_VISIT]: [_logRainEvent],
    [TAG_EVENTS.PODCAST_PAGE_VISIT]: [_logRainEvent],
    [TAG_EVENTS.ADD_TO_CART]: [_logRainEvent, _logEnhanceEcomEvent],
    [TAG_EVENTS.EMAIL_SUBSCRIBED]: [_logRainEvent, _logGoogleAnalyticsEvent],
    [TAG_EVENTS.REFERRAL_LINK_CLICKED]: [_logGoogleAnalyticsEvent],
    [TAG_EVENTS.ORDER_PLACED]: [_logRainEvent],
    [TAG_EVENTS.BUTTON_CLICKED]: [_logGoogleAnalyticsEvent],
    [TAG_EVENTS.VIEWED_CART]: [_logGoogleAnalyticsEvent],
    [TAG_EVENTS.SUBSCRIPTION_SHIP_NOW]: [_logGoogleAnalyticsEvent],
    [TAG_EVENTS.DETAIL_VIEW]: [_logEnhanceEcomEvent],
    [TAG_EVENTS.POST_PURCHASE_SURVEY_COMPLETED]: [_logRockerboxEvent],
  };

  _initService();

  window.cirkulServices = window.cirkulServices || {};
  window.cirkulServices.analyticsTags = {
    TAG_EVENTS: TAG_EVENTS,
    logEvent: logEvent,
  };
  window.resolveCirkulServices.analyticsTags();

  function _initService() {
    const $eventsToLog = $('[data-analytics-tags-log-event]');
    const $ordersToLog = $('[data-analytics-tags-log-order]');

    $eventsToLog.each((index, element) => {
      const $eventToLog = $(element);
      const eventName = $eventToLog.data('analytics-tags-log-event');

      if (TAG_EVENT_HANDLERS[eventName]) {
        logEvent(eventName); // For now these are simple events with no properties.
      }
    });

    $ordersToLog.each((index, element) => {
      const $orderToLog = $(element);
      const $orderLineItems = $orderToLog.find('[data-analytics-tags-order-line-item ]');
      const orderId = $orderToLog.data('analytics-tags-log-order');
      const orderCreatedAt = $orderToLog.data('analytics-tags-order-created-at');
      const orderTotal = parseInt($orderToLog.data('analytics-tags-order-total'));
      const orderTax = parseInt($orderToLog.data('analytics-tags-order-tax'));
      const ordersCount = parseInt($orderToLog.data('analytics-tags-order-count'));
      const orderLineItems = [];
      let orderIsSubscription = false;
      console.log('MARCTEST ORDER TO LOG TO RAIN:', orderId, orderCreatedAt, orderTotal, orderTax);

      $orderLineItems.each((index, element) => {
        const $orderLineItem = $(element);
        const lineItemSku = $orderLineItem.data('analytics-tags-order-line-item-sku');
        const lineItemProductType = $orderLineItem.data('analytics-tags-order-line-item-product-type');
        const lineItemIsGiftCard = $orderLineItem.data('analytics-tags-order-line-item-is-gift-card');
        const lineItemQuantity = $orderLineItem.data('analytics-tags-order-line-item-quantity');
        const lineItemPrice = $orderLineItem.data('analytics-tags-order-line-item-price');
        const lineItemTotal = $orderLineItem.data('analytics-tags-order-line-item-total');

        if (_.includes(lineItemProductType, 'Subscription')) {
          orderIsSubscription = true;
        }

        orderLineItems.push({
          sku: lineItemSku,
          quantity: lineItemQuantity,
          price: lineItemPrice,
        });

        console.log('MARCTEST ORDER TO LOG TO RAIN - LINE ITEM:',
          lineItemSku, lineItemProductType, lineItemIsGiftCard, lineItemQuantity, lineItemTotal);
      });

      logEvent(TAG_EVENTS.ORDER_PLACED, {
        orderId: orderId,
        orderCreatedAt: orderCreatedAt,
        revenue: ((orderTotal - orderTax) / 100).toFixed(2),
        isSubscriptionOrder: orderIsSubscription,
        isFirstOrder: ordersCount === 1,
        lineItems: orderLineItems,
      });
    });
  }

  function logEvent(eventName, eventProperties, eventId) {
    if (!TAG_EVENT_HANDLERS[eventName]) {
      throw new Error(`${eventName} is not a supported event name`);
    }

    if (eventName === TAG_EVENTS.ORDER_PLACED) {
      const currentTimestamp = dayjs();
      const orderCreatedTimestamp = dayjs.unix(eventProperties.orderCreatedAt);
      let alreadyLogged = !!localStorage.getItem(`${ORDER_LOGGED_LOCAL_VARIABLE_PREFIX}:${eventProperties.orderId}`);

      
      alreadyLogged = alreadyLogged || currentTimestamp.diff(orderCreatedTimestamp, 'minute') > 5

      if (alreadyLogged) {
        console.log('Skipping event log -- already done.')
        return;
      }
    }

    const eventHandlers = TAG_EVENT_HANDLERS[eventName];

    _.forEach(eventHandlers, (eventHandler) => {
      eventHandler(eventName, eventProperties, eventId);
    });

    if (eventName === TAG_EVENTS.ORDER_PLACED) {
      localStorage.setItem(`${ORDER_LOGGED_LOCAL_VARIABLE_PREFIX}:${eventProperties.orderId}`, eventProperties.orderId);
    }
  }

  function _logRainEvent(eventName, eventProperties) {
    const eventBody = {
      'event': `rain-analytics:${eventName}`,
    };

    if (eventName === TAG_EVENTS.ORDER_PLACED) {
      eventBody.rainProperties = {
        orderId: eventProperties.orderId,
        revenue: eventProperties.revenue,
        isSubscriptionOrder: eventProperties.isSubscriptionOrder,
        isFirstOrder: eventProperties.isFirstOrder,
        lineItems: eventProperties.lineItems,
      };
    }

    console.log('MARCTEST LOG RAIN EVENT', eventBody);

    window.dataLayer.push(eventBody);
  }

  function _logGoogleAnalyticsEvent(eventName, eventProperties) {
    const eventBody = {
      'event': `google-analytics:${eventName}`,
      'gaProperties': eventProperties,
    };

    console.log('MARCTEST LOG GA EVENT', eventBody);

    window.dataLayer.push(eventBody);
  }

  function _logRockerboxEvent(eventName, eventProperties) {
    const eventBody = {
      'event': `rockerbox:${eventName}`,
      'rockerboxProperties': eventProperties,
    };

    console.log('MARCTEST LOG ROCKERBOX EVENT', eventBody);

    window.dataLayer.push(eventBody);
  }

  function _logEnhanceEcomEvent(eventName, eventProperties, eventId) {
    console.log(`TJN - _logEnhanceEcomEvent`, eventName, eventProperties, eventId);
    // Translate the new event names to the old event names so we don't have to make a ton of GTM updates...
    const enhanceEcomEvents = {
      'DETAIL_VIEW': 'productDetailView',
      'ADD_TO_CART': 'addToCart'
    };

    const eventBody = {
      'event': `enhanceEcom ${enhanceEcomEvents[eventName]}`,
      'ecommerce': {
        ...eventProperties
      },
      eventId: eventId,
    };

    console.log('TIMTEST LOG GA-ECOM EVENT', eventBody);

    window.dataLayer.push(eventBody);
  }
})();
